import React, { Fragment } from 'react';
import { Box, ListItemText, MenuItem } from '@mui/material';

import {
  getInsertableObjectHotCharacter,
  InsertableObject,
} from '../../../../store/selectors/insertableObjectsSelector';

export function InsertableObjectMenuItem({ obj, onClick }: { obj: InsertableObject; onClick: () => void }) {
  let shortcutUnderlineRendered = false;
  const hotCharacter = getInsertableObjectHotCharacter(obj);

  return (
    <MenuItem disabled={obj.disabled ?? false} onClick={onClick}>
      <ListItemText>
        {Array.from(obj.name).map((character, i) => {
          if (hotCharacter == null || shortcutUnderlineRendered || character.toLowerCase() !== hotCharacter) {
            return <Fragment key={i}>{character}</Fragment>;
          }

          shortcutUnderlineRendered = true;

          return (
            <Box component="span" sx={{ textDecoration: 'underline' }} key={i}>
              {character}
            </Box>
          );
        })}
      </ListItemText>
    </MenuItem>
  );
}
